import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";

import APIcon from "./buttons/APIcon";

export type ProgressBarColorOption = "primary" | "error" | "tertiaryGreen";

const APProgressBar = ({
  title,
  value,
  maxValue,
  colorSpectrum,
  largeTitle = false,
  expandText,
  forceOpen,
  forceClose,
  hideExpandToggle = false,
}: {
  title: string;
  value: number;
  maxValue: number;
  colorSpectrum: ProgressBarColorOption[];
  largeTitle?: boolean;
  expandText?: string;
  forceOpen?: boolean;
  forceClose?: boolean;
  hideExpandToggle?: boolean;
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (forceOpen) {
      setExpanded(true);
    }
  }, [forceOpen]);

  useEffect(() => {
    if (forceClose) {
      setExpanded(false);
    }
  }, [forceClose]);

  const progressValue = (value / maxValue) * 100;
  const colorIndex = Math.max(
    Math.floor(colorSpectrum.length * (progressValue / 100)) - 1,
    0
  );

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          cursor: expandText ? "pointer" : "default",
        }}
        onClick={
          expandText && !hideExpandToggle ? handleExpandClick : undefined
        }
      >
        <Typography
          variant={largeTitle ? "bodyLarge" : "labelSmall"}
          color={expandText ? "primary" : "inherit"}
        >
          {title}
        </Typography>
        {expandText && !hideExpandToggle && (
          <APIcon name={expanded ? "arrow-up" : "arrow-down"} />
        )}
      </Box>
      <LinearProgress
        value={progressValue}
        color={colorSpectrum[colorIndex]}
        variant="determinate"
      />
      <Collapse in={!!expanded} sx={{ mt: 1 }}>
        <Typography variant="bodySmall">{expandText}</Typography>
      </Collapse>
    </Box>
  );
};

export default APProgressBar;
